"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useProductLongDescription;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _usePreferredLocale = _interopRequireDefault(require("@sprinx/react-globalize/usePreferredLocale"));

var _useProductLongDescriptionServiceCall = _interopRequireDefault(require("./useProductLongDescriptionServiceCall"));

//
function useProductLongDescription(id) {
  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var locale = (0, _usePreferredLocale.default)(); // const locale = 'cs';

  var getLongDescription = (0, _useProductLongDescriptionServiceCall.default)();

  _react.default.useEffect(function () {
    getLongDescription({
      id: id,
      locale: locale
    }).then(setState);
    return undefined;
  }, [getLongDescription, id, locale, setState]);

  return state || {};
}